export default "__VITE_ASSET__BcFLdARY__";